import React from "react";
import { Link, LinkProps, useParams } from "react-router-dom";

/**
 * A Link component that automatically prefixes paths with the current language.
 * Usage: <LocalizedLink to="/horses">...</LocalizedLink>
 * Renders: <Link to="/en/horses">...</Link>
 */
const LocalizedLink = React.forwardRef<HTMLAnchorElement, LinkProps>(
  ({ to, ...props }, ref) => {
    const { lang } = useParams<{ lang: string }>();
    const currentLang = lang || "en";

    const localizedTo =
      typeof to === "string" && to.startsWith("/")
        ? `/${currentLang}${to === "/" ? "" : to}`
        : to;

    return <Link ref={ref} to={localizedTo} {...props} />;
  }
);

LocalizedLink.displayName = "LocalizedLink";

export default LocalizedLink;
